<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"BUTTON.VIEW" | translate}} {{"RECRUITER.PASTSHIFT" | translate}} </h5>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center mt-3">
        <div class="d-flex justify-content-between">
            <div class="d-flex">
                <div class="profile-img me-2" [appBackgroundImg]="dialogData.profile_picture"></div>
                <div class="">
                    <div class="main-head">{{dialogData.first_name}} {{dialogData.last_name}}</div>
                    <div class="sub-head">{{dialogData.email}}</div>
                </div>
            </div>
        </div>
        <div class="search-cont w-100 mt-4">
            <div class="s-in form-input" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control"
                    [(ngModel)]="searchInput" (input)="onSearch($event)" (keyup.enter)="onGo()" />
            </div>
            <div class="go-b" (click)="onGo()">{{"COMMON.GO" | translate}}</div>
        </div>
        <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
        <div class="table-container flex-grow-1 mt-4" *ngIf="!isSpinnerLoading">
            <table class="" mat-table [dataSource]="dataSource" class="mat-elevation-z8"
                *ngIf="dataSource.data.length!=0">
                <ng-container matColumnDef="company_name">
                    <th mat-header-cell *matHeaderCellDef> Company Name</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="user-profile name table-row-e">
                            <div class="profile-img me-2" [appBackgroundImg]="element.company_logo"> </div>
                            <div class="">
                                <div class="main-head">{{element.company_name}} </div>
                                <div class="sub-head">{{element.email}}</div>
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef> {{"COMMON.DATE"|translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.st_dt | dates}} </td>
                </ng-container>
                <ng-container matColumnDef="time">
                    <th mat-header-cell *matHeaderCellDef>Time</th>
                    <td mat-cell *matCellDef="let element"> {{element.st_ti}} - {{element.ed_ti}} </td>
                </ng-container>
                <!-- <ng-container matColumnDef="clock_in">
              <th mat-header-cell *matHeaderCellDef>Clock In/Out</th>
              <td mat-cell *matCellDef="let element"> -- </td>
            </ng-container> -->
                
                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef> {{"COMMON.CATEGORY"|translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="text-semibold">{{element.j_c }}</div>
                        <div>{{element.j_sc }}</div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="location">
                    <th mat-header-cell *matHeaderCellDef>Location</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="hide-lines-2">{{element.add }}</div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="total_hour">
                    <th mat-header-cell *matHeaderCellDef> Total Hours </th>
                    <td mat-cell *matCellDef="let element"> {{element.wo_ti}}</td>
                </ng-container>
                <ng-container matColumnDef="wages">
                    <th mat-header-cell *matHeaderCellDef> Wages(€)</th>
                    <td mat-cell *matCellDef="let element"> {{element.wages}}/hr</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div class="mat-table__message" *ngIf="dataSource.data.length==0">
                <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
        </div>
        <div class="pagination-cont" *ngIf="dataSource.data.length!=0">
            <div class="show-item">{{"COMMON.SIP" | translate}}
                <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
                    [(ngModel)]="config.itemsPerPage">
                    <option [value]="item" *ngFor="let item of pageSizeOptions"> {{ item }} </option>
                </select>
            </div>
            <div class="page-c">
                <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
                    [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
            </div>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>